<template>
    <div class="center cardGeneral">
        <vs-row class="cardReportes">
          <vs-col  vs-type="flex" vs-justify="center" vs-align="center" w="12" class="mb-4">
            <div class="d-flex">
              <h4 class="p-1">Componentes Académicos</h4>
              <vs-button
                class="ml-auto"
                success
                @click="activeAgregar=!activeAgregar"
              >
                Crear componente académico
              </vs-button>
            </div>
          </vs-col>
          <vs-col sm="12" lg="4">
            <div>
              <form autocomplete="off">
                  <label for="institucion" class="labelInput">
                      Institución <i class="fas fa-shield-alt"></i>
                  </label>
                  <vs-select filter :loading="loadingInstituto" class="aqui pt-0" id="institucion" placeholder="Seleccionar Institución" :key="institucionId" v-model="institucion" :disabled="!instituciones.length">
                      <template #message-danger v-if="errorFields.includes('institucion')">
                          Requerido
                      </template>
                      <vs-option v-for="option in instituciones" :key="option.id"  :label="option.text" :value="option.id">
                          {{option.text}}
                      </vs-option>
                  </vs-select>
              </form>
            </div>
          </vs-col>
          <vs-col sm="12" lg="3" style="margin-top: 23px;">
              <vs-button
                  @click="getInfoComponentes()"
              >
                  <i class="fas fa-search mr-2"></i>Buscar
              </vs-button>
          </vs-col>
          <vs-col w="12">
            <vs-table>
                <template #thead>
                <vs-tr>
                    <vs-th width="50px">
                    </vs-th>
                    <vs-th width="350px">
                      Institución
                    </vs-th>
                    <vs-th>
                      Nombre
                    </vs-th>
                    <vs-th>
                      Escala de calificación
                    </vs-th>
                    <vs-th width="50px">
                      Acciones
                    </vs-th>
                </vs-tr>
                </template>
                <template #tbody>
                <vs-tr
                    :key="i"
                    v-for="(tr, i) in users"
                    :data="tr"
                >
                    <vs-td class="text-center">
                      <i class="far fa-arrow-alt-circle-down" style="font-size: 20px;"></i>
                    </vs-td>
                    <vs-td>
                      {{ tr.nombre_institucion }}
                      {{ tr.nombre_ciclo }}
                    </vs-td>
                    <vs-td>
                      {{ tr.nombre }}
                    </vs-td>
                    <vs-td>
                      {{ tr.nombre_escala }}
                    </vs-td>
                    <vs-td>
                      <md-menu md-direction="bottom-start" md-align-trigger style="z-index: 999">
                        <vs-button
                          shadow
                          md-menu-trigger
                        >
                          <i class="fas fa-ellipsis-v"></i>
                        </vs-button>

                        <md-menu-content>
                          <md-menu-item @click="activeGrupal=!activeGrupal, infoGRupal = tr">Editar</md-menu-item>
                          <md-menu-item @click="activeCrearIndividual=!activeCrearIndividual, infoGRupal = tr">Crear</md-menu-item>
                        </md-menu-content>
                      </md-menu>
                    </vs-td>

                      <!-- <prueba :key="componentKey" :info="tr.detalle_componente"></prueba> -->
                    <template #expand>
                      <div class="con-content">
                        <vs-table>
                          <template #thead>
                            <vs-tr>
                              <vs-th width="120px">
                                Nombre
                              </vs-th>
                              <vs-th>
                                Tipo de calculo
                              </vs-th>
                              <vs-th>
                                Periodos aplicar calculos
                              </vs-th>
                              <vs-th>
                                Decimales
                              </vs-th>
                              <vs-th>
                                Calificación mínima reprobatoria a mostrar en boleta
                              </vs-th>
                              <vs-th>
                                Promedio mínimo acreditable
                              </vs-th>
                              <vs-th>
                                Periodos a ocultar si se logra el promedio mínimo a acreditar
                              </vs-th>
                              <vs-th>
                                Acciones
                              </vs-th>
                            </vs-tr>
                          </template>
                          <template #tbody>
                            <vs-tr
                              :key="j" 
                              v-for="(info,j) in tr.detalle_componente"
                              :data="info"
                              :class="tr.detalle_componente.length > 1 ?'divisionLineas' : ''"
                            >
                              <vs-td class="p-2">
                                <p><strong>{{ info.nombre }}</strong></p>
                                <p class="mb-0"><small>TIPO</small></p>
                                <p class="text-capitalize"><strong>{{ info.tipo }}</strong></p>
                                <p class="mb-0"><small>ORDEN</small></p>
                                <p><strong>{{ info.ponderacion }}</strong></p>
                              </vs-td>
                              <vs-td class="p-2">
                                <p><strong>{{ getTipoCalculo(info.tipo_calculo)}}</strong></p>
                              </vs-td>
                              <vs-td class="p-2">
                                <div v-for="(option, k) in getDetallePromediar(info, tr)" :key="k">
                                  <md-chip class="mini-chip col-blue mt-1" ><strong>{{option}}</strong></md-chip>
                                </div>
                              </vs-td>
                              <vs-td class="p-2">
                                <div v-if="info.decimales_truncar">
                                  <p class="mb-0 text-uppercase"><small>Decimales a truncar</small></p>
                                  <p class="text-capitalize"><strong>{{ info.decimales_truncar }}</strong></p>
                                </div>
                                <div v-if="info.decimales_redondear">
                                  <p class="mb-0 text-uppercase"><small>Decimales a redondear</small></p>
                                  <p class="text-capitalize"><strong>{{ info.decimales_redondear }}</strong></p>
                                </div>
                              </vs-td>
                              <vs-td class="text-center">
                                <p><strong>{{ info.calificacion_minima_reprobatoria }}</strong></p>
                              </vs-td>
                              <vs-td class="text-center">
                                <p><strong>{{ info.promedio_acreditable }}</strong></p>
                              </vs-td>
                              <vs-td  class="p-2">
                                <div v-for="(option, k) in getPeriodoOcultar(info, tr)" :key="k">
                                  <md-chip class="mini-chip col-purple my-1"><strong>{{option}}</strong></md-chip>
                                </div>
                              </vs-td>
                              <vs-td>
                                <vs-button
                                    @click="activeIndividual=!activeIndividual, selectedInfo = info, selectedGeneral = tr, indice = i, fila = j"
                                    success
                                    flat
                                >
                                    <i class="fas fa-edit mr-1"></i> Editar
                                </vs-button>
                              </vs-td>
                            </vs-tr>
                          </template>
                          <template #notFound>
                            No hay información
                          </template>
                        </vs-table>
                      </div>
                    </template>
                    <template #notFound>
                      No hay información
                    </template>
                </vs-tr>
                </template>
                <template #footer>
                  <vs-pagination v-model="page" :length="pages" />
                </template>
            </vs-table>
          </vs-col>
        </vs-row>
        <editar v-model="activeIndividual" :row="selectedInfo" :general="selectedGeneral" @refreshTable="getRefresh"></editar>
        <crear v-model="activeAgregar" @refreshTable="getRefresh" :csrf_token="csrf_token"></crear>
        <editar-grupal v-model="activeGrupal" :row="infoGRupal" @refreshTable="getRefresh"></editar-grupal>
        <crear-individual v-model="activeCrearIndividual" :row="infoGRupal" @refreshTable="getRefresh"></crear-individual>
    </div>
</template>
<script>
import academico from '../../../../api/requests/academico'
import editar from './modales/editar.vue'
import EditarGrupal from './modales/editar-grupal.vue'
import crear from './modales/crear.vue'
import CrearIndividual from './modales/crear-individual.vue'
import prueba from './prueba.vue'
    export default {
      props:[
        'csrf_token'
      ],
      data:() => ({
        institucion:'',
        instituciones: [],
        institucionId: (new Date()).getTime(),
        loadingInstituto: false,
        editActive: false,
        edit: null,
        editProp: '',
        search: '',
        allCheck: false,
        page: 1, 
        max: 10,
        pages: 0,
        active: 0,
        selected: [],
        users: [],
        selectedInfo: [],
        selectedGeneral: [],
        detallesPromediar: [],
        indice: '',
        fila: '',
        activeIndividual:false,
        componentKey: 0,
        activeAgregar: false,
        infoGRupal: [],
        activeGrupal: false,
        activeCrearIndividual: false,
        errorFields: []
      }),
      components: {
        editar,
        prueba,
        crear,
        EditarGrupal,
        CrearIndividual
      },
      created(){
        this.getInstituciones()
        // this.getInfoComponentes()
      },
      methods:{
        async getInstituciones(){
            try {
                this.loadingInstituto = true
                const response = await academico.getInstitucion()
                this.instituciones = response.data
                this.institucionId = (new Date()).getTime()
                this.loadingInstituto = false
            }catch(error){
              console.log(error)
            }
        },
        async getInfoComponentes(){
          try {
              const params = {
                institucion_id: this.institucion,
                page: this.page,
              }
              const { data: response } = await academico.getInfoComponentes(params)
              const { data: dataTable = [], per_page, total = 0 } = response || {}
              this.pages = Math.ceil(total/per_page) || 0
              this.users = dataTable
          }
          catch{

          }
        },
        getRefresh(){
          this.getInfoComponentes()
        },
        async getEscalaCalificaciones(){
            try {
                const response = await reportes.getInstitucion()
                this.instituciones = response.data
            }
            catch{
                
            }
        },
        getDetallePromediar(info, general){
          let detalles = []
          if(info.detalles_promediar){
            info.detalles_promediar.forEach(element => {
              general.detalle_componente.forEach(i => {
                if(element == i.id){
                  detalles.push(i.nombre)
                }
              })
            });
            return detalles
          }
        },
        getPeriodoOcultar(info, general){
          let detalles = []
          if(info.periodos_a_ocultar){
            info.periodos_a_ocultar.forEach(element => {
              general.detalle_componente.forEach(i => {
                if(element == i.id){
                  detalles.push(i.nombre)
                }
              })
            });
            return detalles
          }
        },
        forceRerender () {
          this.componentKey += 1
        },
        getTipoCalculo(tipo){
          if(tipo == 'promedio'){
            return 'Promedio'
          }else if(tipo == 'promedio_condicionado'){
            return 'Promediar con validación'
          }else if(tipo == 'calificacion_acreditable'){
            return 'Calificación acreditable'
          }
        }
      },
      watch:{
        users(){
          this.forceRerender()
        },
        page () {
          this.getInfoComponentes()
        }
      }
    }
</script>

<style lang="scss" scoped>
    .cardReportes{
        width: 100%;
        background-color:white;
        justify-content: space-between;
        @media only screen and (max-width: 768px) {
            margin: 16px;
        }
        @media only screen and (min-width: 768px) {
            margin: 16px 16px;
        }
        border-radius: 3px;
        padding: 10px
    }
    .cardGeneral{
        @media only screen and (max-width: 768px) {
            width: 85%;
        }
        @media only screen and (min-width: 768px) {
            width: 100%;
        }
    }
    @mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
        }
    }
        .md-chip{
        &.mini-chip{
            height: 21px;
            padding: 0px 5px;
            font-size: 12px;
            line-height: 23px;
        }
        @include text-colors ('green', #55ce63, #e8fdeb);
        @include text-colors ('none', #080808, transparent);
        @include text-colors ('red', #f62d51, #f9e7eb); 
        @include text-colors ('yellow', #febf3d, #fff8ec); 
        @include text-colors ('blue', #37aefb, #cfecfe); 
        @include text-colors ('purple', #6F3E90, #E8DAEF); 

    }
    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
</style>

        